import React, { Component } from "react";
import { connect } from "react-redux";
import { Table, Button } from "react-bootstrap";
import moment from "moment";
import { CardList } from '../CardList'

class SobrietyList extends Component {
  render() {
    const { sobrieties, action, isStaffApp } = this.props;

    return (
      <>
        <Table size="sm" responsive>
          <thead>
            <tr>
              <th>Sobriety Date</th>
              <th>Relapse Date</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {
              sobrieties.map((s, i) => {
                return (
                  <tr key={i}>
                    <td>{s.sobriety_date && moment(s.sobriety_date).format("MM/DD/YYYY")}</td>
                    <td>{s.relapse_date && moment(s.relapse_date).format("MM/DD/YYYY")}</td>
                    <td>
                      {
                        action === "edit" &&
                        <a
                          href="#"
                          onClick={(e) => {
                            e.preventDefault();
                            this.props.editSobriety(s);
                          }}>
                          Edit
                        </a>
                      }
                    </td>
                  </tr>
                );
              })
            }
            {
              action == "edit" &&
              <tr>
                <td colSpan={7} className="text-center">
                  <Button
                    variant="link"
                    onClick={() => {
                      this.props.newSobriety();
                    }}>
                    Add Dates
                  </Button>
                </td>
              </tr>
            }
          </tbody>
        </Table>
      </>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    sobrieties: state.sobrieties,
    action: state.ui.action,
    isStaffApp: state.config.isStaffApp,
  };
}

const mapDispatchToProps = (dispatch) => {
  return {
    newSobriety: () => {
      dispatch({
        type: "NEW_RESOURCE",
        payload: { resourceName: "sobriety" }
      })
    },
    editSobriety: (resource) => {
      dispatch({
        type: "EDIT_RESOURCE",
        payload: {
          resourceName: "sobriety",
          resource
        }
      })
    }
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(SobrietyList);
